const isLocalhost = 
    window.location.hostname === 'localhost' || 
    window.location.hostname === '127.0.0.1' || 
    window.location.hostname.startsWith('192.168.') || 
    window.location.hostname.startsWith('10.') || 
    window.location.hostname.startsWith('172.') || 
    window.location.hostname.endsWith('.local');
const port = window.location.port ? `:${window.location.port}` : '';
const API_URL = isLocalhost
    ? `${window.location.protocol}//${window.location.hostname}:8000`
    : `${window.location.protocol}//${window.location.hostname}${port}/api`;

export default API_URL;
